import React, { Component } from 'react';
import DefaultErrorMessage from './ErrorMessage';

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        // You can also log the error to an error reporting service
        console.log({ error, info });
    }

    render() {
        if (this.state.hasError) {
            return <DefaultErrorMessage />;
        }
        return this.props.children;
    }

}


export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/common/ErrorBoundary.js